'use client';

import {Header} from '@ui-kit/src/Header';
import {HeaderProps, MobileMenuProps} from '@ui-kit/src/Header/Header.types';
import {useCallback} from 'react';

import {AuthMenuComponent} from '@web-catalog/components/Auth/AuthMenuComponent';

import {useFilteredHeaderLinks} from '@utils/hooks/useFilteredHeaderLinks';
import {useOmicronFlag} from '@web-catalog/hooks/omicron';

import {logHeaderLinkClick} from '@web-catalog/utils/analytics/headerAnalytics/useHeaderAnalytics';

import {logMenuClose, logMenuItemClick, logMenuOpen} from './menuAnalytics';
import {RightSideContent} from './parts/RightSideContent';
import {useActiveLinkOrder} from './parts/useActiveLinkOrder';

export const StrapiHeader = ({
  handleLinkClick,
  hideSearchButton,
  links,
  ...props
}: HeaderProps & {
  handleLinkClick?: HeaderProps['onLinkClick'];
  hideSearchButton?: boolean;
}) => {
  const onToggleMenu = useCallback((isOpen: boolean) => {
    if (isOpen) {
      return logMenuOpen();
    }

    return logMenuClose();
  }, []);

  const showKiosk = useOmicronFlag('ENABLE_KIOSK_PAGE');
  const excludedTitles = useOmicronFlag('EXCLUDED_HEADER_LINK_TITLES');
  const filteredLinks = useFilteredHeaderLinks({
    links,
    excludedTitles: showKiosk ? excludedTitles : [...excludedTitles, 'Киоск'],
  });
  const activeLinkOrder = useActiveLinkOrder(filteredLinks);

  const onLinkClick = useCallback<NonNullable<HeaderProps['onLinkClick']>>(
    (link, event) => {
      logHeaderLinkClick(link);
      if (handleLinkClick) {
        handleLinkClick(link, event);
      }
    },
    [handleLinkClick],
  );

  const onMenuLinkClick = useCallback<
    NonNullable<MobileMenuProps['onMenuLinkClick']>
  >(
    (link, event) => {
      logMenuItemClick(link.title);
      if (handleLinkClick) {
        handleLinkClick(link, event);
      }
    },
    [handleLinkClick],
  );

  return (
    <Header
      {...props}
      links={filteredLinks}
      onLinkClick={onLinkClick}
      activeLinkOrder={activeLinkOrder}
      rightSideContent={
        <RightSideContent hideSearchButton={hideSearchButton} />
      }
      mobileMenu={{
        mobileMenuTitle: 'Меню',
        footer: <AuthMenuComponent />,
        onToggleMenu,
        onMenuLinkClick,
      }}
    />
  );
};
